import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { checkEmail } from "../services/LoginService";

const SessionGuard = ({ children }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const Loader = () => (
    <div className="loader-container">
      <div className="spinner" />
      <p>Checking session...</p>
    </div>
  );

  useEffect(() => {
    const email = sessionStorage.getItem("login_email");
    if (!email) {
      setLoading(false);
      navigate("/");
      return;
    }

    const checkSubmission = async () => {
      try {
        const hasSubmitted = await checkEmail(email);
        if (!hasSubmitted.success) {
          navigate("/thank-you");
        } else {
          setLoading(false);
        }
      } catch (err) {
        if (err.message === "This user has already sent a video.") {
          navigate("/thank-you");
        } else {
          console.error("Error checking email submission:", err);
        }
        setLoading(false);
      }
    };

    checkSubmission();
  }, [navigate]);

  if (loading) return <Loader />;
  return children;
};

export default SessionGuard;
